import { useMutation } from 'react-query';
import { useAxios } from 'shared/hooks';
export var useAddTourFlag = function () {
    var axios = useAxios();
    return useMutation(function (values) {
        return axios.request({
            method: 'POST',
            data: values,
            url: "/api/v1/experience_states/add_tour_flag",
        });
    });
};
